import React, { useRef } from "react";
import FormContact from "../components/common/FormContact";
import { scrollToForm } from "../utils/Validate";

const HomePage = () => {
  return (
    <>
      <div className="container-fluid px-0 mb-5">
        <div
          id="header-carousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="w-100" src="/img/carousel-1.png" alt="Image" />
              <div className="carousel-caption">
                <div className="container">
                  <div className="row justify-content-end">
                    <div className="col-lg-7 text-end">
                      <h2 className="display-1 text-black mb-4 animated slideInRight">
                        Chào Cuộc Sống Chất Lượng
                      </h2>
                      <p className="fs-4 text-white animated slideInRight">
                        <strong>
                          Phát triển tương lai thịnh vượng <br />
                          và hiện thực hóa nhiều ước mơ của khách hàng
                        </strong>
                      </p>
                      <a
                        className="btn btn-primary rounded-pill py-3 px-5 animated slideInRight"
                        onClick={() => scrollToForm()}
                      >
                        Đăng ký vay ngay
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <img className="w-100" src="/img/carousel-2.png" alt="Image" />
              <div className="carousel-caption">
                <div className="container">
                  <div className="row justify-content-start">
                    <div className="col-lg-7 text-start">
                      <h2 className="display-1 text-white mb-5 animated slideInLeft">
                        Giải pháp tài chính hoàn hảo
                      </h2>
                      <p className="fs-4 text-white animated slideInLeft">
                        Với chiếc thẻ tín dụng
                        <strong>"THE FIRST"</strong>, bạn sẽ được tận hưởng
                        nhiều ưu đãi khi chi tiêu và rút tiền mặt đến 100% hạn
                        mức thẻ
                      </p>
                      <span
                        className="btn btn-primary rounded-pill py-3 px-5 animated slideInLeft"
                        onClick={() => scrollToForm()}
                      >
                        Mở thẻ ngay
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#header-carousel"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#header-carousel"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-0 feature-row">
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
              <div className="feature-item border h-100 p-5">
                <div
                  className="btn-square bg-light rounded-circle mb-4"
                  style={{ width: "64px", height: "64px", textAlign: "center" }}
                >
                  <img
                    className="img-fluid text-center"
                    src="/img/icon/icon-2.png"
                    alt="Icon"
                  />
                </div>
                <h5 className="mb-3">Khách hàng là trọng tâm</h5>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
              <div className="feature-item border h-100 p-5">
                <div
                  className="btn-square bg-light rounded-circle mb-4"
                  style={{ width: "64px", height: "64px" }}
                >
                  <img
                    className="img-fluid"
                    src="/img/icon/icon-1.png"
                    alt="Icon"
                  />
                </div>
                <h5 className="mb-3">Thương hiệu toàn cầu</h5>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
              <div className="feature-item border h-100 p-5">
                <div
                  className="btn-square bg-light rounded-circle mb-4"
                  style={{ width: "64px", height: "64px" }}
                >
                  <img
                    className="img-fluid"
                    src="/img/icon/icon-3.png"
                    alt="Icon"
                  />
                </div>
                <h5 className="mb-3">Tài chính nhân văn</h5>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
              <div className="feature-item border h-100 p-5">
                <div
                  className="btn-square bg-light rounded-circle mb-4"
                  style={{ width: "64px", height: "64px" }}
                >
                  <img
                    className="img-fluid"
                    src="/img/icon/icon-4.png"
                    alt="Icon"
                  />
                </div>
                <h5 className="mb-3">Giá trị & Trải nghiệm</h5>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-xxl about my-5">
        <div className="container">
          <div className="row g-0">
            <div className="col-lg-6">
              <div
                className="h-100 d-flex align-items-center justify-content-center"
                style={{ minHeight: "300px" }}
              >
                <button
                  type="button"
                  className="btn-play"
                  data-bs-toggle="modal"
                  data-src="https://www.youtube.com/watch?v=BMam55_hHoM"
                  data-bs-target="#videoModal"
                >
                  <span></span>
                </button>
              </div>
            </div>
            <div className="col-lg-6 pt-lg-5 wow fadeIn" data-wow-delay="0.5s">
              <div className="bg-white rounded-top p-5 mt-lg-5">
                <p className="fs-5 fw-medium text-primary">Giới thiệu</p>
                <h1 className="display-6 mb-4">Về Chúng tôi</h1>
                <p className="mb-4">
                  Shinhan Finance là một công ty tài chính hàng đầu tại Việt
                  Nam, thuộc tập đoàn Shinhan Financial Group của Hàn Quốc.
                  Shinhan Finance được thành lập vào năm 1993 với tên gọi
                  Prudential Finance và được đổi tên thành Shinhan Finance vào
                  năm 2018.
                  <br />
                  Shinhan Finance cung cấp các sản phẩm và dịch vụ tài chính đa
                  dạng cho khách hàng cá nhân và doanh nghiệp như vay tiêu dùng,
                  thẻ tín dụng, bảo hiểm, cho thuê tài chính và quản lý tài sản.
                  <br />
                  Sứ mệnh của Shinhan Finance là mang lại giải pháp tài chính
                  toàn diện và chất lượng cao cho khách hàng, đồng thời góp phần
                  vào sự phát triển bền vững của xã hội và nền kinh tế Việt Nam.
                </p>
                <div className="row g-5 pt-2 mb-5">
                  <div className="col-sm-6">
                    <img
                      className="img-fluid mb-4"
                      src="/img/icon/icon-5.png"
                      alt=""
                    />
                    <h5 className="mb-3">Cung cấp dịch vụ vay tiêu dùng </h5>
                    <span>Cung cấp gói vay lên tới 300 triệu đồng</span>
                  </div>
                  <div className="col-sm-6">
                    <img
                      className="img-fluid mb-4"
                      src="/img/icon/icon-2.png"
                      alt=""
                    />
                    <h5 className="mb-3">Trải nghiệm của khách hàng</h5>
                    <span>Xây dựng dựa trên niềm tin của khách hàng</span>
                  </div>
                </div>
                <a className="btn btn-primary rounded-pill py-3 px-5" href="">
                  Đăng Ký trải nghiệm
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal modal-video fade"
        id="videoModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-0">
            <div className="modal-header">
              <h3 className="modal-title" id="exampleModalLabel">
                Giới thiệu
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="ratio ratio-16x9">
                <iframe
                  src="https://www.youtube.com/embed/BMam55_hHoM?si=ghl5WdWeA50lMKaV&amp;"
                  title="YouTube video player"
                  allow="autoplay"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                  className="embed-responsive-item"
                  id="video"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <p className="fs-5 fw-medium text-primary">
                Nhận thông tin báo giá
              </p>
              <h1 className="display-5 mb-4">Liên hệ với chuyên viên tư vấn</h1>
              <p>
                Nhân viên ngân hàng luôn thể hiện sự ân cần và chu đáo đối với
                khách hàng vay vốn, lắng nghe kỹ lưỡng những khó khăn, nhu cầu
                và mong muốn của khách hàng. Họ không chỉ cung cấp thông tin chi
                tiết về các gói vay, lãi suất, mà còn sẵn sàng giải đáp mọi thắc
                mắc, giúp khách hàng hiểu rõ về quy trình vay vốn và các cam kết
                đi kèm.
              </p>
              <p className="mb-4">
                Với sự tận tâm, nhân viên hỗ trợ khách hàng từng bước đi đúng
                hướng, tìm ra giải pháp tài chính phù hợp nhất, đảm bảo sự thuận
                tiện và an tâm trong suốt quá trình vay mượn. Sự giúp đỡ chân
                thành này không chỉ mang lại niềm tin cho khách hàng, mà còn tạo
                nên một mối quan hệ lâu dài và bền vững.
              </p>
              <a
                className="d-inline-flex align-items-center rounded overflow-hidden border border-primary"
                href="tel::0838598518"
              >
                <span
                  className="btn-lg-square bg-primary"
                  style={{ width: "55px", height: "55px" }}
                >
                  <i className="fa fa-phone-alt text-white"></i>
                </span>
                <span className="fs-5 fw-medium mx-4">+0838598518</span>
              </a>
            </div>
            <FormContact />
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
